import * as R from 'ramda';

import { setGeo } from './helpers';
import { TGeoValue, IJsonQuery } from './types';

export function removeGeo(jsonQuery: IJsonQuery): (geoValue: TGeoValue) => IJsonQuery {
  return geoValue => {
    if (!jsonQuery.geo || !jsonQuery.geo.value || !R.find(R.equals(geoValue), jsonQuery.geo.value)) {
      return jsonQuery;
    }

    return setGeo()(jsonQuery)(jsonQuery.geo.value.filter(value => !R.equals(value, geoValue)));
  };
}
